function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { SCTE35 } from '@sky-uk-ott/core-video-sdk-js-external-scte35';
import { parse } from '@sky-uk-ott/core-video-sdk-js-external-txml/dist/txml';
import { SegmentationTypeId, SegmentationUpidType, SpliceDescriptorTag } from './scte35.enums';
export { SegmentationTypeId, SegmentationUpidType, SpliceDescriptorTag } from './scte35.enums';
var FREQUENCY_KHZ = 90000;
export var Scte35Parser = /*#__PURE__*/ function() {
    "use strict";
    function Scte35Parser() {
        _class_call_check(this, Scte35Parser);
    }
    _create_class(Scte35Parser, [
        {
            key: "extractScteBase64FromDashSignal",
            value: function extractScteBase64FromDashSignal(xmlString) {
                var xmlScte = '<scte xmlns:scte35="http://www.w3.org/2001/XMLSchema">'.concat(xmlString, "</scte>");
                var signalXml = parse(xmlScte)[0];
                if (typeof signalXml === 'string') return null;
                var signalElement = signalXml.children.filter(function(child) {
                    return typeof child !== 'string' && child.tagName === 'Signal';
                })[0];
                if (!signalElement || typeof signalElement === 'string') {
                    return null;
                }
                var binaryElement = signalElement.children.find(function(e) {
                    return typeof e !== 'string' && e.tagName === 'Binary';
                });
                if (!binaryElement || _instanceof(binaryElement, String)) {
                    return null;
                }
                return binaryElement.children.find(function(elem) {
                    return typeof elem === 'string';
                });
            }
        },
        {
            key: "parseAdDataFromScte35Base64",
            value: function parseAdDataFromScte35Base64(b64binaryData) {
                var scte35Data = this.parseScte35Base64(b64binaryData);
                var adStartSegDescriptor = this.extractSegDescriptor(scte35Data, SegmentationTypeId.PROVIDER_ADVERTISEMENT_START);
                return adStartSegDescriptor ? this.extractAdDataFromAdStartSegDescriptor(adStartSegDescriptor) : null;
            }
        },
        {
            key: "parseScte35Base64",
            value: function parseScte35Base64(b64binaryData) {
                var scte35 = new SCTE35();
                return scte35.parseFromB64(b64binaryData);
            }
        },
        {
            key: "extractSegDescriptor",
            value: function extractSegDescriptor(scteData, segTypeId) {
                var _scteData_descriptors;
                var segmentationDescriptors = (_scteData_descriptors = scteData.descriptors) === null || _scteData_descriptors === void 0 ? void 0 : _scteData_descriptors.filter(this.isSegDescriptor);
                if (!segmentationDescriptors) {
                    return;
                }
                return segmentationDescriptors.find(function(d) {
                    return d.segmentationTypeId === segTypeId;
                });
            }
        },
        {
            key: "extractAdDataFromAdStartSegDescriptor",
            value: function extractAdDataFromAdStartSegDescriptor(descriptor) {
                var segUpId = String.fromCharCode.apply(null, _to_consumable_array(descriptor.segmentationUpid));
                // TODO delete code above on the method and uncomment the following
                // when we use typescript 2.8+
                // const decoder = new TextDecoder();
                // const segUpId = decoder.decode(descriptor.segmentationUpid);
                var contentId = null;
                switch(descriptor.segmentationUpidType){
                    case SegmentationUpidType.MPU:
                        {
                            // TODO: Need a stream to test this use case for MPU
                            // MPU should only be for SLE so we need to test for that
                            var proposition = segUpId.substring(0, 4);
                            if (proposition === 'NBCU') {
                                var nbcuData = JSON.parse(segUpId.substring(4, segUpId.length));
                                contentId = nbcuData.assetId;
                            }
                            break;
                        }
                    case SegmentationUpidType.ADS:
                        contentId = segUpId;
                        break;
                    default:
                        break;
                }
                if (!contentId) {
                    return null;
                }
                return {
                    contentId: contentId,
                    // NOTE the following gives us the duration in seconds
                    duration: descriptor.segmentationDuration / FREQUENCY_KHZ
                };
            }
        },
        {
            key: "isSegDescriptor",
            value: function isSegDescriptor(descriptor) {
                return descriptor.spliceDescriptorTag === SpliceDescriptorTag.SEGMENTATION_DESCRIPTOR;
            }
        }
    ]);
    return Scte35Parser;
}();

//# sourceMappingURL=scte35.js.map